import { useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

export const useRouter = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  useEffect(() => {}, [location]);
  
  const push = (path, queryParams = {}) => {
    const searchParams = new URLSearchParams(queryParams).toString();
    const fullPath = searchParams ? `${path}?${searchParams}` : path;
    navigate(fullPath);
  };

  const replace = (to) => navigate(to, { replace: true });

  const back = () => {
    if (window.history.state) {
      window.history.back();
      // Skip check window.history.length, because of history always big than 2
      // window.history.go(-2);
    } else {
      // TODO please recheck when run to case
      navigate('/', { replace: true }); // Fallback if no history
    }
  };
  
  return {
    push,
    replace,
    back,
    pathname: location.pathname,
    params: params,
  };
};
